import * as React from "react";
import type { SVGProps } from "react";
const SvgCarDoor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 14h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 22H9c-.46 0-.86-.31-.97-.76l-.25-1a7.006 7.006 0 0 0-2.91-4.13l-.43-.28c-.28-.19-.45-.5-.45-.83v-5c0-.27.11-.52.29-.71l5.84-5.83c.94-.94 2.2-1.46 3.54-1.46H19c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1ZM18 4v5H7.413l4.127-4.12c.56-.57 1.32-.88 2.12-.88H18ZM6 11h12v9H9.78v-.01l-.06-.24A8.966 8.966 0 0 0 6 14.46V11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCarDoor;
